"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderTypeToJSON = exports.ProviderTypeFromJSONTyped = exports.ProviderTypeFromJSON = exports.ProviderType = void 0;
/**
 *
 * @export
 */
exports.ProviderType = {
    AiGenerated: 'AI_GENERATED',
    VoiceActor: 'VOICE_ACTOR'
};
function ProviderTypeFromJSON(json) {
    return ProviderTypeFromJSONTyped(json, false);
}
exports.ProviderTypeFromJSON = ProviderTypeFromJSON;
function ProviderTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ProviderTypeFromJSONTyped = ProviderTypeFromJSONTyped;
function ProviderTypeToJSON(value) {
    return value;
}
exports.ProviderTypeToJSON = ProviderTypeToJSON;
